import {
  DireccionDTO,
  ClienteDTO,
  SedeDTO,
} from 'src/app/clientes/utilidades/clientes.models';
import { FilaTabla } from 'src/app/compartido/tabla/utilidades/tabla.models';
import { formatearFecha } from 'src/app/compartido/utilidades/valores.utils';
import { RutaDTO, DomicilioDTO, EstadoDomicilio } from './domicilios.models';

/* Domicilio */
export class Domicilio {
  constructor(
    public id: number,
    public fechaCreacion: string,
    public referencia: string | null,
    public referenciaDisplay: string | null,
    public titulo: string,
    public tipo: string,
    public tipoDisplay: string,
    public prioridad: string,
    public prioridadDisplay: string,
    public estado: EstadoDomicilio,
    public estadoDisplay: string,
    public orden: number | null,
    public recaudo: number,
    public direccion: DireccionDTO,
    public cliente: ClienteDTO,
    public origen: SedeDTO | null,
    public servicio: string | null,
    public notas: string | null,
    public aliado: string | null,
    public antecesor: number | null,
    public sucesor: number | null,
    public fechaCancelacion: string | null,
    public autorCancelacion: string | null,
    public motivoCancelacion: string | null,
    public observacionCancelacion: string | null,
    public fechaEnrutamiento: string | null,
    public idSimpli: number | null,
    public ruta: RutaDTO | null,
    public trackingId: string | null,
    public errores: string | null,
    public fechaDespacho: string | null,
    public autorDespacho: string | null,
    public fechaCheckout: string | null,
    public comentariosCheckout: string | null,
    public observacionCheckout: string | null,
    public fotosCheckout: string[] | null,
    public legalizado: boolean | null,
    public archivoLegalizacion: string | null,
    public fechaLegalizacion: string | null,
    public autorLegalizacion: string | null,
    public observacionLegalizacion: string | null,
  ) {}

  /**
   * Devuelve los datos del domicilio con el formato para tabla
   * @returns {FilaTabla} - Los datos formateados para tabla
   * @author Juan Corral
   */
  public datosTabla(): FilaTabla {
    return {
      id: this.id,
      referencia: this.referencia,
      titulo: this.titulo,
      tipo: this.tipo,
      tipo_display: this.tipoDisplay,
      prioridad: this.prioridad,
      prioridad_display: this.prioridadDisplay,
      estado: this.estado,
      estado_display: this.estadoDisplay,
      fecha_creacion: this.fechaCreacion,
      id_simpli: this.idSimpli,
      vehiculo: this.ruta?.vehiculo?.nombre,
      tracking_id: this.trackingId,
      direccion: this.direccion.direccion_formateada,
      cliente: this.cliente.nombre,
      origen: this.origen?.nombre,
      antecesor: this.antecesor,
      identificacion: this.cliente.identificacion,
      notas: this.notas,
      orden: this.orden,
      fecha_enrutamiento: this.fechaEnrutamiento,
      fecha_despacho: this.fechaDespacho,
      autor_despacho: this.autorDespacho,
      fecha_checkout: this.fechaCheckout,
      legalizado: this.legalizado,
    };
  }

  /**
   * Crea un objeto Domicilio a partir de los datos del API
   * @param {DomicilioDTO} domicilio - El domiclio como llega del API
   * @returns {Domicilio} - El objeto Domicilio creado
   * @author Juan Corral
   */
  public static fromDTO(domicilio: DomicilioDTO): Domicilio {
    return new Domicilio(
      domicilio.id,
      formatearFecha(domicilio.fecha_creacion),
      domicilio.referencia,
      domicilio.referencia_display,
      domicilio.titulo,
      domicilio.tipo,
      domicilio.tipo_display,
      domicilio.prioridad,
      domicilio.prioridad_display,
      domicilio.estado,
      domicilio.estado_display,
      domicilio.orden,
      domicilio.recaudo,
      domicilio.direccion,
      domicilio.cliente,
      domicilio.origen,
      domicilio.servicio,
      domicilio.notas,
      domicilio.aliado,
      domicilio.antecesor,
      domicilio.sucesor,
      domicilio.fecha_cancelacion
        ? formatearFecha(domicilio.fecha_cancelacion)
        : null,
      domicilio.autor_cancelacion,
      domicilio.motivo_cancelacion,
      domicilio.observacion_cancelacion,
      domicilio.fecha_enrutamiento
        ? formatearFecha(domicilio.fecha_enrutamiento)
        : null,
      domicilio.id_simpli,
      domicilio.ruta,
      domicilio.tracking_id,
      domicilio.errores,
      domicilio.fecha_despacho
        ? formatearFecha(domicilio.fecha_despacho)
        : null,
      domicilio.autor_despacho,
      domicilio.fecha_checkout
        ? formatearFecha(domicilio.fecha_checkout)
        : null,
      domicilio.comentarios_checkout,
      domicilio.observacion_checkout,
      domicilio.fotos_checkout ? JSON.parse(domicilio.fotos_checkout) : [],
      domicilio.legalizado,
      domicilio.archivo_legalizacion,
      domicilio.fecha_legalizacion
        ? formatearFecha(domicilio.fecha_legalizacion)
        : null,
      domicilio.autor_legalizacion,
      domicilio.observacion_legalizacion,
    );
  }
}
